export class ProvidersMap extends Map {
    deleteProvider(key) {
        const registration = super.get(key);
        if (!registration) {
            return;
        }
        registration.provider = undefined;
        this.set(key, registration);
    }
    setProvider(key, registration) {
        const newRegistration = Object.assign(Object.assign({}, this.get(key)), registration);
        return this.set(key, newRegistration);
    }
    getProvider(key) {
        var _a;
        return (_a = this.get(key)) === null || _a === void 0 ? void 0 : _a.provider;
    }
    loadProviderByAction(action) {
        const result = Array.from(this.entries()).find(([_, reg]) => { var _a; return (_a = reg.actions) === null || _a === void 0 ? void 0 : _a.includes(action); });
        if (!result) {
            return;
        }
        return this.loadProvider(result[0]);
    }
    loadProvider(key) {
        const registration = this.get(key);
        if (!registration || (!registration.factory && !registration.provider)) {
            return undefined;
        }
        if (!registration.factory || registration.provider) {
            return registration.provider;
        }
        registration.provider = registration.factory();
        return registration.provider;
    }
    clone(providersMap) {
        Array.from(providersMap.keys()).forEach(providerKey => {
            const factory = providersMap.get(providerKey);
            this.set(providerKey, Object.assign(Object.assign({}, factory), { provider: undefined }));
        });
        return this;
    }
}
